<template>
  <div>
    <div class="d-flex align-items-center mt-2 mb-2">
      <!-- left button (decrement) -->
      <button
        type="button"
        class="btn btn-lg btn-primary float-right"
        @click="decrement"
      >
        -
      </button>
      <!-- middle (image) -->
      <div class="col-lg m-1 px-3">
        <div class="bb-img-container">
          <img :src="pass_image" class="bb-img-norm-border img-fluid rounded" />
          <div class="bb-img-text-centered-lg">{{ return_count }}</div>
        </div>
      </div>
      <!-- right button (increment) -->
      <button
        type="button"
        class="btn btn-lg btn-primary float-left"
        @click="increment"
      >
        +
      </button>
    </div>
    <!-- ------------ -->
    <!--    errors    -->
    <!-- ------------ -->
    <div v-if="error" class="row mt-3 bb-error justify-content-center">
      {{ error }}
    </div>
  </div>
</template>

<script>
//----------------------
// scripts
//----------------------
export default {
  name: "CounterImageComponent",
  //----------------------
  // props
  //----------------------
  props: {
    pass_ref: {
      type: String,
      required: true,
    },
    pass_image: {
      type: String,
      required: true,
    },
    pass_count: {
      type: Number,
      required: true,
    },
    pass_min: {
      type: Number,
      required: true,
    },
    pass_max: {
      type: Number,
      required: true,
    },
  },
  //----------------------
  // data
  //----------------------
  data() {
    return {
      error: "",
      return_count: null,
    };
  },
  //----------------------
  // methods
  //----------------------
  methods: {
    //----------------------------
    // increment
    //----------------------------
    increment() {
      this.return_count = this.return_count + 1;
      if (this.return_count > this.pass_max)this.return_count = this.pass_min;
      this.emitter.emit("counter_bleeding", this.return_count);
    },
    //----------------------------
    // decrement
    //----------------------------
    decrement() {
      this.return_count = this.return_count - 1;
      if (this.return_count < this.pass_min) this.return_count = this.pass_max;
      this.emitter.emit("counter_bleeding", this.return_count);
    },
  },
  //----------------------
  // mounted
  //----------------------
  mounted() {
    this.return_count = this.pass_count;
  },
};
</script>